import { Resolutions, Timeout } from '../common/const';
import { isDev, isWidthResize, findAncestorByAttr, setScrollbar } from '../common/utils';
import { pvzListTest } from '../common/mocksup';
import {
    openModal,
    scrollToTop,
    searchObj,

} from '../common/utils';

/**
 * Карта магазинов с всплывающими окнами с информацией
 */
function createMap(props, mapContainer) {
    if (!mapContainer) return;
    let myMap = null;
    if (myMap) return;

    myMap = new ymaps.Map(mapContainer, {
        center: props.center,
        zoom: props.zoom,
        controls: [],
        autoFitToViewport: `always`
    });

    return myMap;
}

let imgSrc = `/img`;
if (!isDev()) imgSrc = `/local/templates/f-plus/img`; // ПОМЕНЯТЬ НА ПРАВИЛЬНЫЙ ПУТЬ НА ПРОДЕ

// скролл двумя пальцами в моб.версии
function setMobileBehaviour(map) {
    const eventsPane = map.panes.get(`events`);
    const eventsPaneEl = eventsPane.getElement();
    const mobilePanelText = `Чтобы переместить карту проведите по ней двумя пальцами`;
    const mobilePanelStyles = {
        alignItems: `center`,
        boxSizing: `border-box`,
        color: `white`,
        display: `flex`,
        justifyContent: `center`,
        fontSize: `22px`,
        fontFamily: `Arial,sans-serif`,
        opacity: `0.0`,
        padding: `25px`,
        textAlign: `center`,
        transition: `opacity .3s`,
        touchAction: `auto`
    };

    Object.keys(mobilePanelStyles).forEach((name) => eventsPaneEl.style[name] = mobilePanelStyles[name]);

    if (Resolutions.IS_MOB()) {
        map.behaviors.disable(`scrollZoom`);
        map.behaviors.disable(`drag`);

        ymaps.domEvent.manager.add(eventsPaneEl, `touchmove`, function (event) {
            if (event.get(`touches`).length === 1) {
                eventsPaneEl.style.transition = `opacity .3s`;
                eventsPaneEl.style.background = `rgba(0, 0, 0, .45)`;
                eventsPaneEl.textContent = mobilePanelText;
                eventsPaneEl.style.opacity = `1`;
            }
        });
        ymaps.domEvent.manager.add(eventsPaneEl, `touchend`, function () {
            eventsPaneEl.style.transition = `opacity .8s`;
            eventsPaneEl.style.opacity = `0`;
        });
    }
}

// генерация маркеров на карте
function createGeoObjects(arr, myMap, balloonContent) {
    let geoObjects = [];
    let mapPointSizes = { width: 30, height: 40, triangleWidth: 15 };

    arr.forEach((el, i) => {
        let BalloonContentLayout = ymaps.templateLayoutFactory.createClass(
            balloonContent[i],
            {
                //Формирование макета
                build: function () {
                    if (Resolutions.IS_NOT_MOB()) {
                        this.constructor.superclass.build.call(this);
                        const geoIndex = this._data.properties.geoIndex;
                        activateServiceBlock(geoIndex);
                        this._$element = $(`.map-info`, this.getParentElement());
                        this.applyElementOffset();
                        this._$element.find(`.close`).on(`click`, $.proxy(this.onCloseClick, this));
                    } else {
                        openModalInfo(balloonContent[i]);
                    }
                },
                //удаление макета из DOM
                clear: function () {
                    if (Resolutions.IS_NOT_MOB()) {
                        this._$element.find(`.close`).off(`click`);
                        this.constructor.superclass.clear.call(this);
                    }
                },
                applyElementOffset: function () {
                    if (Resolutions.IS_NOT_MOB()) {
                        this._$element.css({
                            left: -((this._$element[0].offsetWidth - (mapPointSizes.width / 2) + (mapPointSizes.triangleWidth / 2)) / 2),
                            top: -(this._$element[0].offsetHeight + mapPointSizes.height)
                        });
                    }
                },
                getShape: function () {
                    if (Resolutions.IS_NOT_MOB()) {
                        let position = this._$element.position();
                        return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                            [position.left, position.top], [
                                position.left + this._$element[0].offsetWidth,
                                position.top + this._$element[0].offsetHeight
                            ]
                        ]));
                    }
                },
                onCloseClick: function (e) {
                    if (Resolutions.IS_NOT_MOB()) {
                        e.preventDefault();
                        this.events.fire(`userclose`);
                    }
                },
            });

        geoObjects[i] = new ymaps.Placemark(el["coords"], {}, {
            iconLayout: `default#image`,
            iconImageHref: `${imgSrc}/map-point.svg`,
            balloonShadow: true,
            balloonLayout: BalloonContentLayout,
            balloonPanelMaxMapArea: 1,
            hideIconOnBalloonOpen: false,
            iconImageSize: [mapPointSizes.width, mapPointSizes.height]
        });

        // добавляет кастомный индекс
        geoObjects[i].properties.geoIndex = el["id"];
    });

    let clusterIconContentLayout = ymaps.templateLayoutFactory.createClass(
        `<div style="font-weight: 500; font-size: 20px; color: #FFFFFF;">$[properties.geoObjects.length]</div>`);

    let myClusterer = new ymaps.Clusterer({
        clusterDisableClickZoom: false,
        clusterIcons: [{
            href: `${imgSrc}/map-cluster.svg`,
            size: [mapPointSizes.width, mapPointSizes.height],
            offset: [-mapPointSizes.height/2, -mapPointSizes.height/2]
        }],
        clusterNumbers: [100],
        clusterIconContentLayout: clusterIconContentLayout
    });

    myClusterer.add(geoObjects);
    myMap.geoObjects.add(myClusterer);

    return geoObjects;
}

function openModalInfo(content) {
    openModal(`#modal-services-map-info`, {
        afterLoadCb: (instance, el) => {
            el.$content.addClass(`animation`);
            el.$content.html(content);
        },
        beforeClose: (instance, el) => {
            el.$content.removeClass(`animation`);
        }
    });
}

// установить позицию на карте
function setMapPosition(myMap) {
    if (!myMap) return;
    myMap.container.fitToViewport();
    myMap.setBounds(myMap.geoObjects.getBounds());
    myMap.setZoom(myMap.getZoom()-0.4);
}

// добавляем класс "active" для блока в списке
function activateServiceBlock(geoIndex) {
    const serviceGrid = document.querySelector('[data-service-map-grid]');
    if (!serviceGrid) return
    const allServiceBlocks = serviceGrid.querySelectorAll('[data-service-block]');
    const serviceBlock = findAncestorByAttr(serviceGrid.querySelector(`[data-geo="${geoIndex}"]`), 'data-service-block');

    // добавляем класс "active" для блока в списке
    allServiceBlocks.forEach((block) => block.classList.remove('active'));
    serviceBlock.classList.add('active');

    // скроллим до элемента
    const serviceScrollbar = document.querySelector('.services__map-list .simplebar-content-wrapper');
    if (!serviceScrollbar) return

    serviceScrollbar.scrollTo({
        top: serviceBlock.offsetTop,
        behavior: "smooth",
    });
}

function initContactsMap(data) {
    const map = document.querySelector(`#contacts-map`);
    if (!map) return;

    let myMap = createMap({
        center: data,
        zoom: 16,
    }, map);

    let geoObject = new ymaps.Placemark(data, {
    }, {
        iconLayout: `default#image`,
        iconImageHref: `${imgSrc}/map-logo.svg`,
    });

    myMap.geoObjects.add(geoObject);
    setMobileBehaviour(myMap);
}

function initOrderMap(props) {
    const map = document.querySelector(`#order-map`);
    if (!map || !props) return;
    let myMap = createMap({
        center: [59.939098, 30.315868],
        zoom: 9,
    }, map);

    let contentArr = [];
    props.forEach((el, i) => {
        let content = `
            <div class="map-info">
                <div class="map-info__block">
                    <div class="map-info__title f-lead-m">${el["name"]}</div>
                </div>
                <div class="map-info__block">
        `;

        if (el["card-payment"]) {
            content += `
                <div class="map-info__payment success f-body-s">Оплата картой доступна</div>
            `;
        } else {
            content += `
                <div class="map-info__payment error f-body-s">Оплата картой недоступна</div>
            `;
        }

        if (el["cash-payment"]) {
            content += `
                <div class="map-info__payment success f-body-s">Оплата наличными доступна</div>
            `;
        } else {
            content += `
                <div class="map-info__payment error f-body-s">Оплата наличными недоступна</div>
            `;
        }

        content += `</div>`;
        if (el["route"]) content += `
                    <div class="map-info__block">
                        <div class="map-info__route f-body-s">${el["route"]}</div>
                    </div>`;
        if (el["time"]) content += `
            <div class="map-info__block">
                <div class="map-info__time f-body-s">Выдача посылок: <br>${el["time"]}</div>
            </div>
        `;

        content += `
            <div class="map-info__block">
                <button type="button" class="map-info__btn btn btn--primary f-button-l" data-map-select=${el["id"]}>Выбрать ПВЗ</button>
            </div>
        </div>
        `;

        contentArr.push(content);
    });

    let geoObjects = createGeoObjects(props, myMap, contentArr);

    // клик по внешним ссылкам магазина
    function outerLinksHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        const target = e.target;
        const attr = parseInt(target.getAttribute(`data-map-link`), 10);
        const prevActiveLink = map.querySelector(`.active[data-map-link]`);
        let curGeoObject = geoObjects.find(obj => obj.properties.geoIndex === attr);

        if (curGeoObject) {
            myMap.setCenter(curGeoObject.geometry.getBounds()[0], 15, {
                checkZoomRange: false,
            }).then(() => {
                curGeoObject.balloon.open();
                target.classList.add(`active`);
                if (prevActiveLink) prevActiveLink.classList.remove(`active`);
            });
        }
    }

    function changeOpenBtn() {
        $(`[data-fancybox][data-src="#order-map"]`).html(`<span>Выбрать другой</span>`);
        $(`[data-menu-open="order-map"]`).html(`<span>Выбрать другой</span>`);

        $(`[data-fancybox][data-src="#order-map"]`).removeClass(`btn--primary`);
        $(`[data-fancybox][data-src="#order-map"]`).addClass(`btn--secondary`);

        $(`[data-menu-open="order-map"]`).removeClass(`btn--primary`);
        $(`[data-menu-open="order-map"]`).addClass(`btn--secondary`);
    }

    function selectAddress(e) {
        const target = e.target;
        const attr = parseInt(target.getAttribute(`data-map-select`), 10);
        const item = props.find(obj => parseInt(obj["id"]) === attr);
        if (!item) return;

        let content = `<div class="cart__map-result-title">${item["name"]}</div>`;
        if (item["address"]) content += `<div class="cart__map-result-text">${item["address"]}</div>`;
        if (item["time"]) content += `<div class="cart__map-result-text">Выдача посылок ${item["time"]}</div>`;

        $(`[data-map-result]`).html(content);
        $(`[data-map-result]`).attr(`data-map-result`, item["id"]);

        if ($(`[name="ID_POINT_PVZ"]`).length) $(`[name="ID_POINT_PVZ"]`).val(item["id"]);
        if ($(`[name="ID_POINT_PVZ_ADRES"]`).length) $(`[name="ID_POINT_PVZ_ADRES"]`).val(item["address"]);

        changeOpenBtn();
        $.fancybox.close();

        if (Resolutions.IS_MOB()) {
            $(`[data-menu-close]`).trigger(`click`);
            $(`[data-menu-close]`)[0].dispatchEvent(new Event(`click`));

            // const menu = document.querySelector(`[data-menu="order-map"]`);
            // const overlay = document.querySelector(`.js-overlay`);
            // menu.classList.remove(`animation`);
            // overlay.classList.remove(`animation`);
            //
            // setTimeout(() => {
            //     menu.classList.remove(`opened`);
            //     overlay.classList.remove(`is-viewed`);
            //     document.body.classList.remove(`no-scroll`);
            // }, Timeout.ANIMATION_TIMEOUT);
        }
    }

    myMap.geoObjects.events.add(`balloonopen`, function (e) {
        if (Resolutions.IS_MOB()) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    $(`body`).off(`click`, `[data-map-link]`);
    $(`body`).off(`click`, `[data-map-select]`);
    $(`body`).off(`click`, `[data-src="#order-map"]`);
    $(`body`).off(`click`, `[data-menu-open="order-map"]`);

    $(`body`).on(`click`, `[data-map-link]`, outerLinksHandler);
    $(`body`).on(`click`, `[data-map-select]`, selectAddress);
    $(`body`).on(`click`, `[data-src="#order-map"]`, () => setTimeout(() => setMapPosition(myMap), Timeout.SHORT_TIMEOUT));
    $(`body`).on(`click`, `[data-menu-open="order-map"]`, () => setTimeout(() => setMapPosition(myMap), Timeout.SHORT_TIMEOUT));
    isWidthResize(setMapPosition(myMap));
    setMobileBehaviour(myMap);
}

function initServicesMap(props) {
    const map = document.querySelector(`#services-map`);
    if (!map) return;
    let curRegion;
    let scrollbars = [];

    let myMap = createMap({
        center: [60.356509, 76.538681],
        zoom: 3,
    }, map);

    // формируем выпадающий список стран
    function createDropdown(arr, purp) {
        arr = arr.sort((a, b) => a.localeCompare(b));

        const temps = document.querySelectorAll(`[data-dropdown="${purp}"]`);

        for (let temp of temps) {
            const btn = temp.querySelector(`[data-toggle-btn]`);
            btn.querySelector(`span`).textContent = btn.getAttribute(`data-dropdown-text`);
            const list = temp.querySelector(`[data-toggle-block]`);
            list.innerHTML = ``;

            for (let element of arr) {
                let item = document.createElement(`li`);
                item.classList.add(`dropdown__item`);
                let link = document.createElement(`a`);
                link.classList.add(`dropdown__link`, `f-body-s`, `link`, `link--dropdown`, `js-service-country`);
                link.textContent = element;

                link.setAttribute(`data-${purp}`, element);
                link.setAttribute(`data-dropdown-value`, element);
                link.setAttribute(`data-dropdown-id`, element);
                // temp.setAttribute(`data-dropdown-list`, purp);

                item.append(link);
                list.append(item);
            }
        }
    }

    // добавляет дропдауны на страницу
    function addDropdown(data) {
        let wraps = document.querySelectorAll(`[data-dropdown]`);
        for (let wrap of wraps) {
            for (let name of [`country`, `region`, `city`]) {
                createDropdown(createCountries(data), name);
            }
        }

        $(`[data-dropdown="region"]`).addClass(`disabled`);
        $(`[data-dropdown="city"]`).addClass(`disabled`);
    }

    // Формирует список стран
    function createCountries(arr) {
        let countries = [];

        arr.forEach((el) => {
            let {country} = el;
            if (!countries.includes(country)) {
                countries.push(country);
            }
        });
        return countries;
    }

    // Формирует список регионов
    function createRegions(arr) {
        let regions = [];

        arr.forEach((el) => {
            let {region} = el;
            if (!regions.includes(region)) {
                regions.push(region);
            }
        });
        return regions;
    }

    // Формирует список городов
    function createCities(arr) {
        let cities = [];

        arr.forEach((el) => {
            let {city} = el;
            if (!cities.includes(city)) {
                cities.push(city);
            }
        });
        return cities;
    }

    // Добавляет скроллбар
    function createScrollbars() {
        if (Resolutions.IS_DP()) {
            if (scrollbars) for (let scrollbar of scrollbars) scrollbar.unMount();
            scrollbars = setScrollbar(document.querySelectorAll(`[data-service-scrollbar]`));
        }
    }

    // очищаем контент страниц
    function clearContent() {
        document.querySelector(`[data-service-grid]`).innerHTML = ``;
        document.querySelector(`[data-service-map-grid]`).innerHTML = ``;
    }

    // формируем контент страницы
    function createShoplist(arr, shopTemp, container) {
        arr.forEach((el) => {
            let temp = shopTemp.cloneNode(true);
            let {id, name, country, region, city, address, phones, email, working_time, site} = el;

            // формируем блоки с магазинами
            temp.querySelector(`.services__lead .js-map-link`).textContent = name;
            if (temp.querySelector(`[data-service-modal]`)) {
                temp.querySelector(`[data-service-modal]`).setAttribute(`data-service-modal`, id);
            }

            let content = ``;
            content += `<div class="services__text-block">${country}, ${region}, ${city}, ${address}</div>`;

            if (phones) {
                content += `<div class="services__text-block">`;
                for (let phone of phones) {
                    content += `<div class="services__text"><a class="services__link link" href="tel:${phone}">${phone}</a></div>`;
                }
                content += `</div>`;
            }

            temp.querySelector(`.services__info`).innerHTML = content;

            temp.querySelector(`[data-service-block]`).setAttribute(`data-country`, country);
            temp.querySelector(`[data-service-block]`).setAttribute(`data-region`, region);
            temp.querySelector(`[data-service-block]`).setAttribute(`data-city`, city);
            temp.querySelector(`.js-map-link`).setAttribute(`data-geo`, id);

            container.append(temp);
        });
    }

    function getContentArr(arr) {
        let contentArr = [];

        arr.forEach((el, i) => {
            let content = `
            <div class="map-info map-info--services">
                <div class="map-info__block">
                    <div class="map-info__title f-lead-m">${el["name"]}</div>
                </div>
        `;

            if (el["working_time"]) {
                content += `
                <div class="map-info__block">
                    <div class="map-info__subtitle f-lead-m">Рабочее время:</div>
            `;

                for (let time of el["working_time"]) {
                    content += `<div class="map-info__text f-body-s">${time}</div>`;
                }
                content += `</div>`;
            }

            if (el["phones"]) {
                content += `
                <div class="map-info__block">
                    <div class="map-info__subtitle f-lead-m">Телефон:</div>
            `;

                for (let phone of el["phones"]) {
                    content += `<div class="map-info__text f-body-s">
                    <a href="tel:${phone}" class="map-info__link link">${phone}</a>
                </div>`;
                }
                content += `</div>`;
            }

            if (el["email"]) {
                content += `
                <div class="map-info__block">
                    <div class="map-info__subtitle f-lead-m">email:</div>
            `;

                for (let email of el["email"]) {
                    content += `<div class="map-info__text f-body-s">
                    <a href="mailto:${email}" class="map-info__link link">${email}</a>
                </div>`;
                }
                content += `</div>`;
            }

            if (el["site"]) {
                content += `
                <div class="map-info__block">
                    <div class="map-info__subtitle f-lead-m">Сайт:</div>
                    <div class="map-info__text f-body-s">
                        <a href="${el["site"]}" class="map-info__link link" target="_blank">${el["site"]}</a>
                    </div>
                </div>
            `;
            }

            content += `
            <div class="map-info__block">
                <div class="map-info__subtitle f-lead-m">Адрес:</div>
                <div class="map-info__text f-body-s">${el["country"]}, ${el["region"]}, ${el["city"]}, ${el["address"]}</div>
            </div>
            <div class="map-info__block">
                <a href="https://yandex.ru/maps/?pt=${el["coords"][1]},${el["coords"][0]}&z=16&l=map" class="map-info__btn btn btn--big btn--primary f-button-m" target="_blank">
                    <span>Маршрут на Яндекс картах</span>
                </a>
            </div>
        </div>
        `;

            contentArr.push(content);
        });

        return contentArr;
    }

    let contentArr = getContentArr(props);
    let geoObjects = createGeoObjects(props, myMap, contentArr);

    // клик по внешним ссылкам магазина
    function outerLinksHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        $(`[data-tab="services-map"]`).trigger(`click`);
        const target = e.target;
        const attr = target.getAttribute(`data-geo`);
        const $curTab = $(`[data-tab].active`);
        let curGeoObject = geoObjects.find(obj => parseInt(obj.properties.geoIndex) === parseInt(attr));

        myMap.setCenter(curGeoObject.geometry.getBounds()[0], 15, {
            checkZoomRange: false,
        }).then(() => {
            curGeoObject.balloon.open();
        }).then(() => {
            if ($curTab.attr(`data-tab`) === `services-list`) {
                const top = $(`#service-body`).offset().top - $(`header`).outerHeight(true);
                scrollToTop(top, Timeout.ANIMATION_TOGGLE);
            }
        });
    }

    // Перерисовка карты
    function redrawMap(attr) {
        myMap.geoObjects.removeAll();
        let newMapProps = props;
        if (attr) newMapProps = props.filter((el) => el.country === attr);
        contentArr = getContentArr(newMapProps);
        geoObjects = createGeoObjects(newMapProps, myMap, contentArr);

        if (newMapProps.length > 1) {
            setMapPosition(myMap);
        } else {
            myMap.setCenter(newMapProps[0].coords, 6, { checkZoomRange: true });
        }
    }

    // Сменить страну/регион/город в фильтре
    function changeCountryHandler(e) {
        e.preventDefault();
        let tag, attr;

        for (let name of [`country`, `region`, `city`]) {
            if ($(e.target).data(name)) {
                tag = name;
                attr = $(e.target).data(name);
            }
        }

        const $selectedList = $(`[data-dropdown="${tag}"]`);
        const $selectedLink = $(`.js-service-country[data-${tag}="${attr}"]`);

        $selectedList.find(`[data-toggle-btn] span`).text(attr);
        // $(e.target).closest(`[data-dropdown]`).find(`[data-toggle-btn]`).trigger(`click`);
        $(e.target).closest(`[data-toggle-container]`).removeClass(`opened`);
        $(e.target).closest(`[data-toggle-container]`).find('[data-toggle-block]').slideUp(0);

        $selectedLink.addClass(`active`);
        $selectedLink.parent().siblings().find(`.js-service-country`).removeClass(`active`);
        $selectedLink.siblings(`.js-service-country`).removeClass(`active`);

        $(`[data-service-block]`).hide();
        $(`[data-service-block][data-${tag}="${attr}"]`).show();

        // Выбор страны
        if (tag === `country`) {
            const arr = props.filter((el) => el.country == attr);
            createDropdown(createRegions(arr), `region`);
            createDropdown(createCities(arr), `city`);
            $(`[data-dropdown]`).removeClass(`disabled`);

            // перерисовка карты
            redrawMap(attr);
        } else if (tag === `region`) {
            // Выбор региона
            const arr = props.filter((el) => el.region == attr);
            createDropdown(createCities(arr), `city`);

            $.getJSON(`https://geocode-maps.yandex.ru/1.x/?apikey=ada025f7-bedf-458a-964a-13bdb3fc853f&format=json&geocode=${encodeURIComponent(attr)}`, function( data ) {
                const arrRes = data.response.GeoObjectCollection.featureMember;
                let value = arrRes.find(function(obj) {
                    return searchObj(obj, attr);
                });

                myMap.geoObjects.remove(curRegion);

                if (value != null) {
                    let coords = value.GeoObject.Point.pos.split(` `).reverse().map(function(item) {
                        return Number(item);
                    });

                    ymaps.borders.load(`RU`, {
                        lang: `ru`,
                        quality: 1,
                    }).then(function (geojson) {
                        let feature = geojson.features.find((el) => el.properties.name === attr);

                        curRegion = new ymaps.GeoObject(feature, {
                            'strokeColor': `#F32735`,
                            'strokeWidth': 2,
                            'fillColor': `rgba(0, 0, 0, 0)`
                        });
                        myMap.geoObjects.add(curRegion);
                        myMap.setCenter(coords, 6, { checkZoomRange: true });
                    });
                } else {
                    setMapPosition(myMap);
                }
            });
        } else if (tag === `city`) {
            // Выбор города
            attr = attr
                .replace(`г `, ``)
                .replace(`п `, ``)
                .replace(`пгт `, ``);

            $.getJSON(`https://geocode-maps.yandex.ru/1.x/?apikey=ada025f7-bedf-458a-964a-13bdb3fc853f&format=json&geocode=${encodeURIComponent(attr)}`, function(data) {
                const arrRes = data.response.GeoObjectCollection.featureMember;

                let value = arrRes.find(function(obj) {
                    return searchObj(obj, attr);
                });

                if (value != null) {
                    let coords = value.GeoObject.Point.pos.split(` `).reverse().map(function(item) {
                        return Number(item);
                    });
                    myMap.setCenter(coords, 12, { checkZoomRange: true });
                } else {
                    setMapPosition(myMap);
                }
            });
        }

        $(e.target).parents(`.toggle-list`).addClass(`no-focus`);
        createScrollbars();
    }

    // Сброс фильтров
    function resetFilterMapHandler() {
        redrawMap();
        renderContent();
    }

    // Открытие модалки
    function onModalLinkClick(e) {
        e.preventDefault();
        const attr = $(e.target).attr(`data-service-modal`);
        let arr = props.find(obj => obj["id"] === attr);
        let content = getContentArr([arr]);
        openModalInfo(content);
    }

    // формируем контент страницы
    function renderContent() {
        clearContent();
        createShoplist(props, document.querySelector(`#service-template`).content, document.querySelector(`[data-service-grid]`));
        createShoplist(props, document.querySelector(`#service-template-map`).content, document.querySelector(`[data-service-map-grid]`));
        // формируем выпадающий список стран
        addDropdown(props);
        createScrollbars();
        isWidthResize(setMapPosition(myMap));
        setMobileBehaviour(myMap);
    }

    renderContent();
    // переключение стран
    $(`body`).on(`click`, `.js-service-country`, changeCountryHandler);
    $(`body`).on(`click`, `.js-map-link`, outerLinksHandler);
    $(`body`).on(`click`, `.js-service-reset`, resetFilterMapHandler);
    $(`body`).on(`click`, `[data-tab="services-map"]`, () => {
        setTimeout(() =>  {
            setMapPosition()
        }, Timeout.SHORT_TIMEOUT);
    });
    $(`body`).on(`click`, `[data-service-modal]`, onModalLinkClick);
}

export const initMap = () => {
    // order-map
    if (isDev()) {
        // $.getJSON(`json/delivery-list.json`, (data) => ymaps.ready(() => initOrderMap(data)));
        ymaps.ready(() => initOrderMap(pvzListTest));

        // contacts-map
        const contactsData = [55.794937, 37.712995];
        ymaps.ready(() => initContactsMap(contactsData));

        // services-map
        if (document.querySelector(`#services-map`)) {
            window.loadingStart(true);
            $.getJSON(`../json/services.json`, (data) => {
                ymaps.ready(() => {
                    initServicesMap(data);
                    if ($(`.js-service-country[data-country="Россия"]`).length) {
                        $(`.js-service-country[data-country="Россия"]`).trigger(`click`);
                    }
                    window.loadingEnd();
                });
            });
        }
    } else {
        // order-map
        if (window.pvzList) ymaps.ready(() => initOrderMap(window.pvzList));

        // contacts-map
        if (document.querySelector(`#contacts-map`)) {
            const contactsData = [55.794937, 37.712995];
            ymaps.ready(() => initContactsMap(contactsData));
        }

        // services-map
        if (document.querySelector(`#services-map`)) {
            window.loadingStart(true);
            $.getJSON(`/service/json.php`, (data) => {
                ymaps.ready(() => {
                    initServicesMap(data);
                    if ($(`.js-service-country[data-country="Россия"]`).length) {
                        $(`.js-service-country[data-country="Россия"]`).trigger(`click`);
                    }
                    window.loadingEnd();
                });
            });
        }
    }
};

window.initMap = (type, data) => {
    ymaps.ready(() => {
        if (type === `order`) {
            initOrderMap(data);
        } else if (type === `contacts`) {
            initContactsMap(data);
        } else if (type === `services`) {
            initServicesMap(data);
        }
    });
};
